import { Component } from "@angular/core";
import { UserToken } from "@app/_models";
import { Router } from "@angular/router";
import { AuthenticationService } from "@app/_services";
import { ResizeService } from "./_services/resize.service";
import { SCREEN_SIZE } from "./_helpers/screen-size.enum";
import { InventoryService } from "@app/_services/inventory.service";
import { Inventory } from "@app/_models/_DTOs/inventory";
import { ITuple } from "@app/_models/tuple";
import { SelectionService } from "./_services/selection.service";
import { BaseComponent } from "./_shared/base.component";
import { LegalEntityService } from "./_services/legalEntity.service";
import { LegalEntity } from "./_models/_DTOs/legalEntity";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent extends BaseComponent {
  onScreenResize(screenSize: SCREEN_SIZE) {
    this.screenSize = screenSize;
    if (
      this.screenSize == SCREEN_SIZE.XS ||
      this.screenSize == SCREEN_SIZE.SM
    ) {
      this.openNavBar();
    }
  }
  onUserAvailable(userToken: UserToken) {
    if (this.inventoryService) {
      this.refreshInventories();
    }
    if (this.legalEntityService) {
      this.refreshLegalEntities();
    }
  }
  isCollapsed = false;
  currentUser: UserToken = null;
  screenSize: SCREEN_SIZE;

  inventoriesInProgress: Inventory[];
  legalEntities: LegalEntity[];

  mouseOutTimer = null;

  constructor(
    private router: Router,
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService,
    private inventoryService: InventoryService,
    private selectionService: SelectionService,
    private legalEntityService: LegalEntityService
  ) {
    super(authenticationService, resizeService);
  }

  ngOnInit() {
    if (this.CurrentUser) {
      this.refreshInventories();
      this.refreshLegalEntities();
    }
  }

  refreshLegalEntities() {
    this.legalEntityService.getAllBasic().subscribe((data: LegalEntity[]) => {
      this.legalEntities = data;
    });
  }

  refreshInventories() {
    this.inventoryService
      .getInventoriesInProgress()
      .subscribe((data: Inventory[]) => {
        this.inventoriesInProgress = data;
        if (
          this.inventoriesInProgress &&
          this.inventoriesInProgress.length > 0
        ) {
          this.router.navigate([
            "/inventory/" + this.inventoriesInProgress[0].id,
          ]);
        }
      });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(["/login"]);
  }

  getCollapsedSize() {
    if (this.screenSize < SCREEN_SIZE.MD) {
      return 0;
    } else {
      return 80;
    }
  }

  openNavBar() {
    this.isCollapsed = false;
  }

  collapseNavBar() {
    this.isCollapsed = true;
  }

  onNavMouseOver() {
    if (this.mouseOutTimer != null) {
      clearTimeout(this.mouseOutTimer);
    }
    this.openNavBar();
  }

  onNavMouseOut() {
    if (this.mouseOutTimer != null) {
      clearTimeout(this.mouseOutTimer);
    }
    this.mouseOutTimer = setTimeout(() => {
      this.collapseNavBar();
    }, 500);
  }
}
